<div class="operations-page">

  <div class="header">
    <h2>Operations</h2>
  </div>

  <div class="search-container">
    <input type="text" pInputText [(ngModel)]="searchText" placeholder="Search Operations" />
  </div>

  <div class="services-grid">
    <div class="service-card" *ngFor="let service of filteredServices"
      (click)="service.action ? service.action() : null">
      <div class="icon-container">
        <i class="pi" [ngClass]="service.icon" [ngStyle]="{ color: service.color }"></i>

        <div *ngIf="service.name === 'Leave Tracker' && pendingLeaveCount > 0" class="side-badge">
          {{ pendingLeaveCount }}
        </div>

        <div *ngIf="service.name === 'Attendance Approval' && pendingAttendanceCount > 0" class="side-badge">
          {{ pendingAttendanceCount }}
        </div>
        <div *ngIf="service.name === 'Expense & Reimbursement' && expensePendingCount > 0" class="side-badge">
          {{ expensePendingCount }}
        </div>

        
      </div>

      <div class="service-name">{{ service.name }}</div>
    </div>
  </div>

</div>